import ComponentStatuses from '../../components/componentStatuses';
import QueueStatuses from '../../components/queueStatus';

const Status = () => {
  return (
    <>
      <ComponentStatuses></ComponentStatuses>
      <QueueStatuses></QueueStatuses>
    </>
  );
};

export default Status;
